import { mpsEndpoints } from '../mps/mps-endpoints';

export const environment = {
  production: false,
  envName: 'dev',
  api: {
    host: 'https://api-d.flowreclampp.alzp.tgscloud.net/',
    providers: mpsEndpoints.providers,
  },
  loaderOnHttp: true,
  defaultLocale: 'en',
  allowedLanguage: ['en'],
  appName: 'Flow',
  mpsIcons: ['bin', 'edit', 'gray-edit', 'filter', 'upload', 'excel', 'user', 'info', 'pdf', 'pdf-file', 'three-dots', 'account-circle', 'search'],
  appIcons: [],
  translationsSource: 'local',
  allowImpersonation: false,
  reporting: {
    fcReportingLink: 'https://app.powerbi.com/groups/me/apps/e82ad480-18a1-4828-8217-59c7c5421de8/reports/0e94cb48-6cb5-4b17-915f-2db213102457/ReportSection63f682fc02df5805a38f?experience=power-bi',
    fiReportingLink: 'https://app.powerbi.com/groups/me/apps/e82ad480-18a1-4828-8217-59c7c5421de8/reports/0e94cb48-6cb5-4b17-915f-2db213102457/61f795ef74e317370c2e?experience=power-bi',
    svReportingLink: ''
  }
};
